export const handleSubmit =
    (actionCreator, ...args) =>
    (e) => {
        e?.preventDefault();
        actionCreator(...args);
    };

export const handleSubmitWithDispatch =
    (dispatch, actionCreator, ...args) =>
    (e) => {
        e?.preventDefault();
        dispatch(actionCreator(...args));
    };

export const fetchData = async (dispatch, fetcher, filter, setValues) => {
    const defaultValues = await dispatch(fetcher(filter));
    if (setValues) {
        setValues({
            ...defaultValues,
            waiting: false,
        });
    }

    return defaultValues;
};

export const onClosePopup = (onClose) => () => {
    document.getElementById("overlay").style.display = "none";

    if (onClose) setTimeout(() => onClose(), 200);
};

export const onOpenPopup = () => () => {
    document.getElementById("overlay").style.display = "block";
};

export const getDynamicLink = (prefix, path, params) => {
    if (params) {
        const queryString = Array.from(params.entries())
            .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
            .join("&");
        return `${prefix}/${path}?${queryString}`;
    }
    return `${prefix}/${path}`;
};

// Debounce function to avoid multiple requests
export const debounce = (func, timeout = 300) => {
    let timer;

    return function (...args) {
        clearTimeout(timer);
        timer = setTimeout(() => {
            func(...args);
        }, timeout);
    };
};

// ClassNames function
export const classNames = (...classes) => {
    return classes.filter(Boolean).join(" ");
};

// Table state checker function
export const getTableState = (data) => {
    // Check if data is loading
    if (data.waiting) {
        return "loading";
    }

    // Check if data is empty or invalid
    if (!data.order || !data.content || data.order.length <= 0) {
        return "empty";
    }

    // Data has content
    return "hasData";
};

// Get app name based on environment
export const getAppName = () => {
    const appUrl = process.env.REACT_APP_APP_URL;

    if (appUrl && appUrl.includes("localhost")) {
        return "Local";
    } else if (appUrl && appUrl.includes("staging")) {
        return "Staging";
    } else {
        return "MiFisio";
    }
};
